import type { TOC } from '@ember/component/template-only'
import type RexDashboardStudentAssignmentsIndexRoute from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/assignments/index/route'
import RouteTemplate from 'ember-route-template'
import { DashboardStudentAssignmentsPage } from 'teacher-ui-client/components/page/reporting/reading-eggspress/dashboard/student/assignments'

interface Signature {
  Args: { model: ModelFor<RexDashboardStudentAssignmentsIndexRoute> }
}

export const DashboardStudentAssignmentsIndexPage: TOC<Signature> = <template>
  <DashboardStudentAssignmentsPage
    @fetchAssignmentsOverviewReportTask={{@model.fetchAssignmentsOverviewReportTask}}
    @fetchAssignmentsEventsReportTask={{@model.fetchAssignmentsEventsReportTask}}
  />
</template>

export default RouteTemplate(DashboardStudentAssignmentsIndexPage)
